var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"internal_trade_container"},[_vm._v(" 公司在浦东地区租有3000m²的仓库，实现了二十四小时监控的安保系统，充分保证了入库货物的安全。具备了集装箱内装、分拨及货物保管、中转、整理、包装等一系列作业能力。仓库拥有二十辆集卡，可为各类进出口集装箱货物提供门到门服务。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }